<div *ngIf="orderData.rules?.client_id == 'w'">
  <form [formGroup]="clientForm">
    <!-- Client -->
    <div class="row">
      <div class="col-6 mb-5 buscador d-block">
        <label for="client" class="form-label"
          >{{ "inputs.client" | translate }}
          <span class="required">*</span></label
        >
        <div class="client-selector">
          <div class="main-selector-container">
            <div
              class="selector-container-supplier"
              [ngClass]="{ expanded: optionsVisibleClient }"
              [ngClass]="{ 'disabled-select': isClientInputDisabled }"
            >
              <input
                type="text"
                (focus)="onFocus('client')"
                (blur)="hideOptions()"
                placeholder="{{ 'inputs.client' | translate }}"
                (input)="searchClients($event.target)"
                [value]="displayTextClient"
                [disabled]="isClientInputDisabled"
              />
              <input type="hidden" formControlName="client_id" />
              <span class="icon-chevron-down arrow"></span>
            </div>

            <div
              class="options-container"
              *ngIf="optionsVisibleClient"
              [ngClass]="{ visible: optionsVisibleClient }"
            >
              <div
                class="option-value"
                *ngFor="let client of filteredClients"
                (mousedown)="onSelectClient(client)"
              >
                <div>
                  {{ client.name }}
                  {{ client.lastname ? client.lastname : "" }}
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="client_selector_spinner"
            class="spinner-border text-info"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <label
          *ngIf="!orderData.client"
          for="client"
          class="text_add"
          (click)="openClientForm('client')"
          >{{ "inputs.new_client" | translate }}
        </label>
      </div>
    </div>
  </form>
</div>
<div *ngIf="orderData.client">
  <div class="row" [hidden]="orderData.client && step == 2">
    <div class="col-6">
      <div class="column-list">
        <label>{{ "inputs.client" | translate }}</label>
        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.client?.name + ' ' + orderData.client?.lastname"
            #inputClientName
          />
          <div class="input-group-append">
            <a *ngIf="orderData.client && account_type == 'broker'"
              [href]="goClientForm(orderData.client.reference)"
              class="btn btn-outline-secondary copy"
              [title]="'forms.names.editClient' | translate">
              <i class="icon-pencil"></i>
            </a>
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputClientName.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>

        <div class="input-group justify-content-end">
          <div class="clear">
            <button
              *ngIf="orderData.client?.assignee"
              class="btn btn-hover clear-button ml-15"
              type="button"
              (click)="openAssigneeForm()"
            >
              {{ "inputs.see_assignee" | translate }}
              {{ orderData.client?.assignee.name }}
              <i class="icon-chevron-right"></i>
            </button>
          </div>
        </div>

       
          <label>{{ "inputs.identification" | translate }}</label>
          <div class="input-group div-copy">
            <input
              type="text"
              class="form-control"
              disabled
              [value]="orderData.client?.tax_id"
              #inputFieldtax_id
            />

            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary copy"
                type="button"
                (click)="copyToClipboard(inputFieldtax_id.value, $event)"
              >
                <i class="icon-copy"></i>
              </button>
            </div>
        </div>

          <label>{{ "inputs.contact" | translate }}</label>

          <div class="input-group div-copy">
            <input
              type="text"
              class="form-control"
              disabled
              [value]="orderData.client?.email"
              #inputFieldemail
            />

            <div class="input-group-append">
              <button *ngIf="orderData.client?.email"
                class="btn btn-outline-secondary copy"
                type="button"
                (click)="openMailModal(orderData.client.reference)"
                [title]="'buttons.send_mail' | translate"
              >
                <i class="icon-envelope"></i>
              </button>
              <button
                class="btn btn-outline-secondary copy"
                type="button"
                (click)="copyToClipboard(inputFieldemail.value, $event)"
              >
                <i class="icon-copy"></i>
              </button>
            </div>
          </div>
          <label>{{ "inputs.phone" | translate }}</label>

          <div class="input-group div-copy">
            <input
              type="text"
              class="form-control"
              disabled
              [value]="orderData.client?.phone"
              #inputFieldphone
            />

            <div class="input-group-append">
              <button
                *ngIf="canUseVoip"
                class="btn btn-outline-success copy"
                type="button"
                [disabled]="!orderData.client?.phone"
                [style.opacity]="orderData.client?.phone ? 1 : 0.5"
                [style.cursor]="orderData.client?.phone ? 'pointer' : 'not-allowed'"
                (click)="openCallPanel()"
                [title]="'call_panel.start_call' | translate"
              >
                <i class="icon-telephone"></i>
              </button>
              <button
                class="btn btn-outline-secondary copy"
                type="button"
                (click)="
                  copyToClipboard(
                    extractPhoneNumber(inputFieldphone.value),
                    $event
                  )
                "
              >
                <i class="icon-copy"></i>
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class="col-6">
      <div class="column-list">
        <label>{{ "inputs.direction" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.client?.billing_address"
            #inputFieldbilling_address
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldbilling_address.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>

        <label>{{ "inputs.billing_postal_code" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.client?.billing_postal_code"
            #inputFieldbilling_postal_code
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="
                copyToClipboard(inputFieldbilling_postal_code.value, $event)
              "
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        <label>{{ "inputs.billing_state" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.client?.billing_state"
            #inputFieldbilling_state
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldbilling_state.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        <label>{{ "inputs.billing_city" | translate }}</label>

        <div class="input-group div-copy">
          <input
            type="text"
            class="form-control"
            disabled
            [value]="orderData.client?.billing_city"
            #inputFieldbilling_city
          />

          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary copy"
              type="button"
              (click)="copyToClipboard(inputFieldbilling_city.value, $event)"
            >
              <i class="icon-copy"></i>
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
<div class="input-group justify-content-end mt-2"  [hidden]="orderData.client && step == 2">
          <button
            type="submit"
            class="btn btn-primary d-flex align-items-center gap-2"
            (click)="step = 2"
          >
            {{ "inputs.next" | translate }}
            <i class="icon-arrow-right btn-next"></i>
          </button>
        </div>
  <div [hidden]="orderData.client && step == 1">
    <form [formGroup]="clientFormExtra">
      <div class="row">
        <div class="col-6">
          <div class="column-list">
            <label for="client_gender" class="form-label">{{ "inputs.client_gender" | translate }}</label>
            <ng-select
              formControlName="client_gender"
              [items]="genderOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.gender." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.gender." + item.key | translate }}
              </ng-template>
            </ng-select>
            <label for="client_housing_type" class="form-label">{{ "inputs.client_housing_type" | translate }}</label>

            <ng-select
              formControlName="client_housing_type"
              [items]="housingTypeOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.housing_type." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.housing_type." + item.key | translate }}
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="col-6">
          <div class="column-list">
            <label for="client_marital_status" class="form-label">{{ "inputs.client_marital_status" | translate }}</label>
            <ng-select
              formControlName="client_marital_status"
              [items]="maritalStatusOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.marital_status." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.marital_status." + item.key | translate }}
              </ng-template>
            </ng-select>

            <label for="client_employment_situation" class="form-label">{{
              "inputs.client_employment_situation" | translate
            }}</label>

            <ng-select
              formControlName="client_employment_situation"
              [items]="employmentOptions"
              bindValue="key"
              [placeholder]="'inputs.select_option' | translate"
              [searchable]="true"
              [clearable]="false"
              [notFoundText]="'tables.no_results' | translate"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ "inputs.employment_situation." + item.key | translate }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ "inputs.employment_situation." + item.key | translate }}
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="column-list">
            <label>{{ "inputs.client_bank_account" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.client_bank_account"
                #inputFieldclient_bank_account
                formControlName="client_bank_account"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(inputFieldclient_bank_account.value, $event)
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="column-list">
            <label>{{ "inputs.client_employer_tax_id" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.client_employer_tax_id"
                #inputFieldclientEmployerTaxId
                formControlName="client_employer_tax_id"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(inputFieldclientEmployerTaxId.value, $event)
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
            <label for="client_employer_from_date" class="form-label"
              >{{ "inputs.client_employer_from_date" | translate }}
            </label>
            <mat-form-field appearance="fill">
              <input
                matInput
                [matDatepicker]="client_employer_from_date"
                formControlName="client_employer_from_date"
                placeholder="{{
                  'inputs.client_employer_from_date' | translate
                }}"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="client_employer_from_date"
              ></mat-datepicker-toggle>
              <mat-datepicker #client_employer_from_date></mat-datepicker>
            </mat-form-field>
            <label>{{ "inputs.client_employer_address" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.client_employer_address"
                #inputFieldclient_employer_address
                formControlName="client_employer_address"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(
                      inputFieldclient_employer_address.value,
                      $event
                    )
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="column-list">
            <label>{{ "inputs.client_employer_name" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.client_employer_name"
                #inputFieldclientEmployerName
                formControlName="client_employer_name"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(inputFieldclientEmployerName.value, $event)
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>

            <label>{{ "inputs.client_mounthly_net_income" | translate }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.client_monthly_net_income"
                #inputFieldclientMounthlyNetIncome
                formControlName="client_monthly_net_income"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(
                      inputFieldclientMounthlyNetIncome.value,
                      $event
                    )
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>

            <label>{{
              "inputs.client_employer_postal_code" | translate
            }}</label>

            <div class="input-group div-copy">
              <input
                type="text"
                class="form-control"
                [value]="orderData.client_employer_postal_code"
                #inputFieldclient_employer_postal_code
                formControlName="client_employer_postal_code"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary copy"
                  type="button"
                  (click)="
                    copyToClipboard(
                      inputFieldclient_employer_postal_code.value,
                      $event
                    )
                  "
                >
                  <i class="icon-copy"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="input-group justify-content-start mt-2">
          <button
            type="submit"
            class="btn btn-primary d-flex align-items-center gap-2"
            (click)="step = 1"
          >
            <i class="icon-arrow-left btn-next"></i>
            {{ "inputs.back" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

